<input
  [ngModel]="value"
  (ngModelChange)="onNewValue($event)"
  class="input"
  type="text"
  placeholder="DD/MM/YYYY"
/>
